import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 导入样式
import './styles/base.css'
import './styles/common.css'
// majestic
import './../majestic/css/style.css'
import './../majestic/vendors/mdi/css/materialdesignicons.min.css'
import './../majestic/vendors/base/vendor.bundle.base.css'
// 字体图标的样式
import './assets/iconfont/iconfont.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
